// extracted by mini-css-extract-plugin
module.exports = {"app":"zeus_homepage_float_rightbar1817_app__6B91x"};